import gql from 'graphql-tag';

export default gql`
    mutation EditAssetLoadNotes($input: AssetLoadNotesEdit) {
        editAssetLoadNotes(input: $input) {
            errors
        }
    }
`;
